export enum ConceptualHqEvent {
  // Prequel 1: remove after deploy Prequel 2
  LoanInformation = 'Prequal Status Changed: Loan Info page',
  BorrowerInformation = 'Prequal Status Changed: Borrower Info page',
  BorrowerIncome = 'Prequal Status Changed: Borrower Income page',
  CoBorrowerInformation = 'Prequal Status Changed: Coborrower Info page',
  CoBorrowerIncome = 'Prequal Status Changed: Coborrower Income page',
  ContractorInformation = 'Prequal Status Changed: Contractor Info page',
  //Prequel 2
  Borrower = 'Prequal Status Changed: Borrower page',
  CreateAccount = 'Prequal Status Changed: Create Account page',
  SignIn = 'Prequal Status Changed: Sign In page',
  Coborrower = 'Prequal Status Changed: Coborrower Info',
  Financial = 'Prequal Status Changed: Financial Info',
  Property = 'Prequal Status Changed: Property Info',
  Offers = 'Prequal Status Changed: Offer Accepted',
}
